import React from 'react';
import { Button } from '@chakra-ui/react';
import { FiChevronsDown, FiChevronsUp } from 'react-icons/fi';

interface ExpandCollapseAllButtonProps {
  allOpen: boolean;
  onToggle: () => void;
  size?: string;
  isDisabled?: boolean;
}

// item 496 (Chad) — ONE consistent "expand all / collapse all" control, reused across every
// collapsible tree/ledger in the app (My Book's All Commissions, the accountant dashboard's
// section groups + Enter-to-QuickBooks buckets, the sidebar project tree, …) so the affordance
// always looks and behaves the same everywhere it appears.
const ExpandCollapseAllButton: React.FC<ExpandCollapseAllButtonProps> = ({
  allOpen, onToggle, size, isDisabled,
}) => (
  <Button
    size={size}
    variant="ghost"
    leftIcon={allOpen ? <FiChevronsUp /> : <FiChevronsDown />}
    onClick={onToggle}
    isDisabled={isDisabled}
  >
    {allOpen ? 'Collapse all' : 'Expand all'}
  </Button>
);

ExpandCollapseAllButton.defaultProps = {
  size: 'sm',
  isDisabled: false,
};

export default ExpandCollapseAllButton;
